import Vue from 'vue'
import Router from 'vue-router'
import index from '@/page/index/index'
import userAgreement from '@/page/index/userAgreement'
import privacyPolicy from '@/page/index/privacyPolicy'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'index',
      component: index
    }, 
		{
		  path: '/userAgreement',
		  name: 'userAgreement',
		  component: userAgreement
		},
		{
		  path: '/privacyPolicy',
		  name: 'privacyPolicy',
		  component: privacyPolicy
		},
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js